<form [formGroup]="form" class="p-6 max-w-lg mx-auto" (ngSubmit)="onSave()">
  <h2 class="text-xl font-bold mb-4">Report Setting</h2>
  <div class="mb-4">
    <label class="block font-medium mb-2">Way of Reporting</label>
    <label class="inline-flex items-center mr-4">
      <input type="radio" formControlName="method" value="mail" /> Mail
    </label>
    <label class="inline-flex items-center mr-4">
      <input type="radio" formControlName="method" value="api" /> API
    </label>
    <label class="inline-flex items-center">
      <input type="radio" formControlName="method" value="shared-folder" /> Shared Folder
    </label>
  </div>
  <div *ngIf="form.value.method === 'mail'" class="mb-4">
    <label class="block font-medium mb-2">Email <span class="text-red-600">*</span></label>
    <input type="email" formControlName="email" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('email')?.errors?.['required']">Email is required.</div>
      <div *ngIf="form.get('email')?.errors?.['email']">Enter a valid email address.</div>
    </div>
  </div>
  <div *ngIf="form.value.method === 'api'" class="mb-4">
    <label class="block font-medium mb-2">API URL <span class="text-red-600">*</span></label>
    <input type="text" formControlName="apiUrl" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('apiUrl')?.touched && form.get('apiUrl')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('apiUrl')?.errors?.['required']">API URL is required.</div>
    </div>
    <label class="block font-medium mb-2 mt-2">API Key <span class="text-red-600">*</span></label>
    <input type="text" formControlName="apiKey" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('apiKey')?.touched && form.get('apiKey')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('apiKey')?.errors?.['required']">API Key is required.</div>
    </div>
    <label class="block font-medium mb-2 mt-2">API Username <span class="text-red-600">*</span></label>
    <input type="text" formControlName="apiUsername" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('apiUsername')?.touched && form.get('apiUsername')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('apiUsername')?.errors?.['required']">API Username is required.</div>
    </div>
    <label class="block font-medium mb-2 mt-2">API Password <span class="text-red-600">*</span></label>
    <input type="password" formControlName="apiPassword" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('apiPassword')?.touched && form.get('apiPassword')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('apiPassword')?.errors?.['required']">API Password is required.</div>
    </div>
  </div>
  <div *ngIf="form.value.method === 'shared-folder'" class="mb-4">
    <label class="block font-medium mb-2">Folder URL <span class="text-red-600">*</span></label>
    <input type="text" formControlName="folderUrl" class="border rounded px-3 py-2 w-full" />
    <div *ngIf="form.get('folderUrl')?.touched && form.get('folderUrl')?.invalid" class="text-red-600 text-sm mt-1">
      <div *ngIf="form.get('folderUrl')?.errors?.['required']">Folder URL is required.</div>
    </div>
  </div>
  <button type="submit" class="mt-4 px-4 py-2 bg-primary text-white rounded" [disabled]="form.invalid || loading || !form.touched">Save</button>
  <div *ngIf="error" class="text-red-600 mt-2">{{ error }}</div>
</form> 